export const WhatIsBinany = `Trading is one of the most modern and profitable tools for money making.

Ranked among the easiest types of earnings, trading on this platform is peculiar because it deals with guessing the price change of a certain currency or raw material (asset). No  need to possess a single knowledge in the field of economics or finance; or any course at all. Things are easy: you only need to predict whether the price of a certain asset will rise or fall. Visually, this process will be depicted on the graph.

# What do you need to know?

Where there is a risk, there is always a profit. Where there is profit, there is always a risk. Before you start making profit, (up to 90% of the transaction amount) you need to know that every risk (as well as every income) is fixed in advance.

As mentioned earlier, making a deal is one of the easiest and most affordable ways to make money. The expression "the more you invest, the more you earn" is totally inappropriate here. The minimum bet (bid; transaction amount) on Binany is 30 rupees. And the minimum deposit amount is 300 rupees.

# What is the point?

First you need to make a deal. We select the expiration time (i.e. closing time), and wait for the cherished seconds to be over. The platform will check if you have made the correct forecast, and if it turns out to be correct, then you get a profit of up to 90% of the invested amount.

# How about an order?

1. Choose an asset.
    - At Binany, there is an opportunity to work with a variety of currency pairs, raw materials, various stocks of global companies, and, undoubtedly, exchange indices of countries from almost all over the world.
2. Select the amount of the transaction.
    - Here we do not forget that the amount of your profit (which can reach 90%) will depend on the amount of the transaction.
3. Time.
    - Yes, you will need to choose the time after which, as you think, your prediction will be justified.
4. Up and down.
    - Your last action. Based on different elements and knowledge, you will need to choose the direction of the graph using the up and down buttons.

As you understand, just 4 simple steps. This is why working in trading is becoming more and more popular every day. No other investment tool will allow you to get such a high income in such a short time. The last advantage of trading is that you do not need to download any additional software; you do not need to have an economic or financial education. To generate income, it is enough just to have a small idea of the economic market and to have access to the latest news in the financial and economic spheres. `

export const Terms = `

### **General Terms and Conditions**

These Terms and Conditions (hereinafter referred to as the "**Agreement**") constitutes a legally binding contract governing the use of the Binany platform. The Agreement is entered into between the Client (hereinafter referred to as the "**Client**") and Finpulse LLC, a legal entity incorporated under the laws of the island of Nevis, with registration number L 23523 and registered office located at Suite 1, A.L. Evelyn Ltd Building, Main Street, Charlestown, Nevis, West Indies (hereinafter referred to as the "**Company**"). Collectively, the Client and the Company are referred to as the "**Parties**".


Binany is an online platform providing services via various digital tools and systems, including but not limited to its primary website (binany.com and associated subdomains), mobile applications (iOS, Android), APIs, social media modules, and other web-based or digital resources specified by the Company from time to time (hereinafter referred to as the “**Website**”).


This Agreement constitutes a public offer addressed to an indefinite number of individuals. By accessing or using the Website, the Client confirms that they have read, understood, and agreed to all terms and conditions contained herein. If the Client does not agree with any part of this Agreement, all access to the Website, account functionalities, or other related services must be discontinued immediately.


The Company reserves the right to modify this Agreement at its sole discretion and without prior notice. Any changes will take effect immediately upon their publication on the Website. The Client undertakes to regularly review the current version of this Agreement and its appendices to remain informed about any updates. Continued use of the Website or related services by the Client after any modifications constitutes acceptance of the revised Agreement. The Company bears no liability or any consequences arising from the Client’s failure to review updates to this Agreement.



1. **1. Definitions**

To avoid ambiguity and other misunderstandings in the interpretation of the text of this Agreement, the Parties have agreed that the following terms shall have the meanings defined below:

1.1. **Account** — means a unique personified account registered in the name of the Client and which contains all the Client’s transactions/ operations on the Website of the Company.

1.2. **Account Balance** — The total amount of funds deposited by the Client to the Account, excluding bonuses and open trades. The Account Balance reflects the Client’s deposits adjusted for withdrawals and fees, unless otherwise specified.

1.3. **Asset** — Stock indices, shares, commodities, and currency available for trading using financial instruments provided by the Company.

1.4. **Bonuses, Bonus Funds** — Funds credited by the Company to the Client's Account to increase its trading potential. Bonuses are not a financial obligation of the Company to the Client.

1.5. **CFD (Contract for Difference)** — A tradable contract entered into between the Client and the Company, who exchange the difference in the value of an Instrument, as specified on the Trading Platform at the time of opening a Transaction, and the value of that Instrument at the contract’s end.

1.6. **Customer’s Real Account** — A special Customer’s account on the Trading Platform, reflecting in real time the results of Non-trading operations conducted by it, Open and Closed transactions, and other changes in the Company's financial obligations to the Customer.

1.7. **Deposit** — Funds deposited by the Client to the Account.

1.8. **Execution** — The execution of Client order(s) by the Company acting as the Client's counterparty as per the terms of the present agreement.

1.9. **Expiration** — The moment of execution of the Transaction.

1.10. **FATCA Reported Person** — Any individual or entity classified as a United States Person, including U.S. citizens, residents (determined by the substantial presence test unless exempted), or any other person with substantial U.S. ownership, whose foreign financial accounts or assets meet the reporting thresholds under FATCA.

1.11. **Log file** — a file containing system information about the operation of the Company’s Server and information about the Client’s actions on the Website.

1.12. **Non-trading operation** — a transaction on depositing or Withdrawing funds from the Client's Account, as well as other operations that are not Trading.

1.13. **Quote** — a digital value of an asset at a given point in time.

1.14. **Server** — a software and hardware complex, which provides a quote flow to the client in real time, as well as in the processing of the client's trading Instructions.

1.15. **Strike price** — the Asset Quotation predicted by the Client at the close of the Transaction.

1.16. **The Client's Personal Account** — a section of the Website with restricted access, through which the Client, after passing the authorization procedure by entering a login and password, has the opportunity to use the Company services.

1.17. **Trading mechanics** — derivatives from asset financial instruments provided by the Company on the trading platform, the use of which does not result in the actual acquisition of the Asset.

1.18. **Trading operation** — an over-the-counter operation with an Asset, performed between the Company and the Customer in non-deliverable mode.

1.19. **Trading Order** — an order of the Client to make a Trading operation on the conditions specified in such an order.

1.20. **Trading Platform** — a computer system that is accessed through the Client’s Personal Account, used to display Quotes streams transmitted from the Company’s Server, to place Client’s Trading Orders, to reflect the results of their execution, and to perform other actions related to the execution of Trading Operations.

1.21. **Transaction** — the opposite of trade operations having the same identification number.

1.22. **Withdrawal of funds** — taking out funds from the Account and transfer thereof according to the details of the Client.

Other terms may be used in the Agreement that are not defined in this section. In this case, the interpretation of such a term shall be made by the text of the Agreement. In the absence of a clear interpretation of the term in the text of the Agreement, the term shall be interpreted: primarily – by the legislation of the island of Nevis, secondarily – with the content of the Website, and then – with the established (commonly used) meaning on the Internet.



1. **2. General Provisions**

2.1.  By registering and creating an Account on the Website, the Client signifies acceptance of the Agreement. This acceptance indicates the Client’s full and unconditional agreement to its terms.  

2.2.  The location for the provision of services is the island of Nevis.  

2.3.  The Privacy Policy and Cookie Policy published on the Website are integral parts of this Agreement.  

2.4.  The Client confirms they have read, understood, and accepted all the information, terms, and conditions set out on the Website, which are publicly available for review and contain important legal information.  

2.5.  By accepting this Agreement, the Client irrevocably agrees to the terms and conditions within this Agreement, including its annexes and/or appendices, as well as any other documents or information available on the Website. This includes, but is not limited to, the Privacy Policy and other policies published at the website.  

2.6. The Client formally accepts this Agreement by registering an Account on the Website. Upon acceptance the Client establishes a legally binding agreement with the Company.  

2.7.   The Client’s acceptance of this Agreement shall be deemed to be the Client’s registration on the Company’s Website. Once the registration is completed, all actions taken by the Client on the Trading Platform are governed by this Agreement and other documentation/information on the Website.  

2.8. The Client acknowledges that each operation, activity, transaction, order, and communication conducted on the Trading Platform, through their Account, and on the Website shall be governed by and executed in accordance with the terms of this Agreement and other Website documentation/information.  

2.9. By accepting this Agreement, the Client confirms they are able to receive information, including updates to this Agreement, either via email or through the Website.  

2.10. Subject to the terms of this Agreement, the Company agrees to provide Services to the Client, provided that the Client:  

2.10.1. Is of legal age and competent according to the laws of their place of residence.  

2.10.2. Does not reside in a country where the Company’s financial products or services would conflict with local regulations. It is the Client’s responsibility to determine and comply with any relevant local laws or regulations.  

2.10.3. Is not a US person or its territories, nor of Canada, Afghanistan, Australia, Belgium, Bouvet Island, Cuba, Democratic Republic of the Congo, Eritrea, Ethiopia, Gibraltar, Haiti, Iran, Israel, Libya, Mali, Myanmar, North Korea, Palestine, South Sudan, Sudan, Syria, the Russian Federation, the United Kingdom, Ukraine, the Vatican, any country in the European Economic Area, or other non-serviced countries.  

2.11. The Company reserves the right to provide Services to the Client at its sole discretion, subject to the conditions of this Agreement.  

2.12. The Client is strictly prohibited from conducting any transaction or operation on the Trading Platform, Website, or through their Account that would exceed the total balance or amount of funds deposited or maintained in their Account. These deposited amounts are deemed as collateral, either through a lien or similar mechanism, ensuring the Client’s obligation to pay the Company is secured. 

3. **3. Services of the Company**

3.1. The Company will facilitate the execution of the Client’s trade activities, orders, and transactions; however, the Client acknowledges that the Company will not provide any trust services, trading consultations, or advisory services at any time.  

3.2. All Client transactions and operations will be processed by the Company in accordance with this Agreement on an execution-only basis.  

3.2.1. The Company will neither manage the Client’s Account nor provide any form of advice.  

3.2.2. The Company will process Client orders and transactions regardless of whether they benefit the Client.  

3.2.3. Unless otherwise specified in this Agreement or other Website documentation, the Company has no obligation to monitor or advise on any transaction/order status, issue margin calls, or close any open positions.  

3.2.4. The Company is not required to attempt to process Client orders/transactions using quotes more favorable than those provided on the Trading Platform.  

3.3. The Company is not financially liable for any operations the Client conducts through their Account and/or on the Trading Platform.  

3.4. Each Client is the sole authorized user of the Company’s services and their associated Account.  

3.4.1. The Client has an exclusive, non-transferable right to use and access the Account.  

3.4.2. The Client is responsible for ensuring no third party—including family members—gains access or trades through the assigned Account.  

3.5. The Client is responsible for all orders and other transactions/operations given through their security information.  

3.5.1. Orders received in this way will be considered issued by the Client.  

3.5.2. The Company will reasonably assume all orders submitted through the Client’s Account are made by the Client, with no obligation to further investigate.  

3.5.3. The Company holds no liability or legal relationship with any third party other than the Client.  

3.6. If the Client acts on behalf of or in the name of any third party, the Company will not recognize this third party as a Client and holds no liability toward them, regardless of identification.  

3.7. The Client has the right to cancel an order within three seconds of placing it (the “**Cancellation**”).  

3.7.1. The Client understands that this three-second cancellation applies only when the price remains unchanged.  

3.7.2. Within three seconds of the order being placed, the Company may (but is not obligated to) offer a “**Buyout**” option to purchase the order from the Client, who may accept if they wish.  

3.7.3. The Client’s right to Cancellation or Buyout is subject to the conditions on the platform, including any applicable fees, which are specified on the platform.  

3.7.4. The Company provides all necessary details on Cancellation and Buyout terms, costs, etc., through the platform, which the Client agrees is sufficient.  

3.7.5. The Client acknowledges the high risks involved with using Cancellation or Buyout, as the cost depends on market conditions, and accepts full responsibility for these risks.  

3.8. The Client may use the Cancellation or Buyout option under the conditions specified on the Trading Platform/Website, including any fees the Company may charge.  

3.8.1. The Company is obligated to provide all necessary information about Cancellation and Buyout conditions, including related costs, through the Trading Platform, which the Client accepts as adequate.  

3.8.2. The Client agrees that utilizing the Cancellation or Buyout options carries significant risks, particularly when these costs vary with market conditions, and they assume all associated risks.  

3.9. The Client understands and agrees that the Company may, at its discretion, use third parties to hold Client funds or for payment processing services.  

3.10. Any reports, news, opinions, or information provided by the Company to the Client do not constitute investment advice or research. No information material on the Website should be construed as investment advice. 

1. **4. Execution and Processing of Orders**

4.1. The Client accepts and understands that all orders received shall be executed by the Company as the counterparty of the transaction in its capacity of market maker.  

4.1.1. The Company shall act as a principal and not as an agent on the Client’s behalf for the purpose of executing orders.  

4.1.2. The Client is informed that conflicts of interest may arise because of this model.  

4.2. Following submission of a request/order, the process includes:

4.2.1. Testing the request/order for correctness on the Trading Platform.

4.2.2. Transmitting the request/order from the Trading Platform to the server.

4.2.3. Testing the request/order for correctness by the server.

4.2.4. Returning the server’s processing results to the Trading Platform.

4.3. The time required for processing may vary based on communication quality and market conditions. Under normal conditions, processing time is typically 0–4 seconds. In volatile or abnormal market conditions, delays may occur.

4.4. Reception of an order by the Company does not constitute acceptance. Acceptance occurs only when the order is executed.

4.5. The Company may act as an intermediary for client transactions and bears no responsibility for the content of the order or the identity of the individual placing it.

4.6. The Company reserves the right to refuse to execute orders under the following circumstances: 

4.6.1. If the execution may result in market manipulation, insider trading, or money laundering.

4.6.2. If the Client has insufficient funds or fails to meet obligations under this Agreement.

4.6.3. If the request/order is submitted before the market opens or in abnormal market conditions, such as high volatility or instability.

4.6.4. If technical or mechanical issues prevent orderly processing.

4.7. The use of multiple browser tabs or external trading bots may lead to errors or order cancellation.

4.8. The Client acknowledges and accepts the following risks:

4.8.1. Mistakes or misinterpretations in orders due to technical or mechanical failures.

4.8.2. Delays or other issues arising from communication problems between the Trading Platform and the server.

4.8.3. Unauthorized access to the Client’s account by third parties.

4.9. The Client agrees to indemnify the Company for any losses resulting from acting in accordance with the Client's orders.

4.10. The Company may liquidate the Client’s positions under certain market conditions or due to the availability of the underlying asset.

4.11. The Company will provide prior notification to the Client before liquidating a position, whenever possible.

4.12. The Company shall bear no responsibility for:

4.12.1. Financial losses or technical issues arising from the use of external trading bots.

4.12.2. The availability of products or services offered at its discretion.

4.13. The Company shall have the right, at its sole discretion, to refuse to execute orders in the following circumstances:  

4.13.1. If the execution of the order aims or may aim to manipulate the market price of financial instruments (market manipulation).  

4.13.2. If the execution of the order constitutes or may constitute abusive exploitation of confidential information (insider trading).  

4.13.3. If the execution of the order contributes or may contribute to the legalization of the proceeds of illegal activities (money laundering).  

4.13.4. If the Client has insufficient funds or financial instruments to cover the transaction.  

4.13.5. If the Client fails to fulfill any obligations towards the Company under this Agreement.  

4.13.6. If the Client seeks to become or becomes a US Reportable Person or a resident of a non-serviced country.  

4.14. The Client acknowledges that, under certain market conditions or due to the availability of the underlying asset, the Company may close all or part of the Client’s positions.  

4.14.1. The Company undertakes to provide prior notification to the Client in case a position will be liquidated.  

1. **5. Trading Mechanics**

5.1. The following Trading Mechanics are available to the Client:  

5.1.1. Standard  

5.1.1.1. When opening a Transaction, the Client indicates the Asset, the Transaction amount, the direction of the chart, and the time of closing the Transaction.  

5.1.1.2. The Transaction closes upon reaching the selected closing time.  

5.1.1.3. If, at the moment of closing the Transaction, the current quotation of the selected Asset is higher than its quotation at the opening, the Transaction is considered profitable if the selected direction of movement of the chart is “up.”  

5.1.1.4. If, at the moment of closing the Transaction, the current quotation of the selected Asset is lower than its quotation at the opening, the Transaction is considered profitable if the selected direction of movement of the chart is “down.”  

5.1.1.5. The yield on the Transaction is fixed and depends on the selected amount of the Transaction, the Asset, and the Transaction execution time.  

5.1.1.6. The income under the Transaction is defined as the percentage yield multiplied by the amount of the Transaction.  

5.1.2. Strike  

5.1.2.1. When opening a Transaction, the Client indicates the Asset, the Transaction amount, the direction of movement of the chart, the Strike price, and the closing time of the Transaction.  

5.1.2.2. The Transaction closes upon reaching the selected closing time.  

5.1.2.3. If, at the moment of closing the Transaction, the current quotation of the selected Asset is higher than the Strike price indicated by the Client, the Transaction is considered profitable if the selected direction of the chart is “up.”  

5.1.2.4. If, at the moment of closing the Transaction, the current quotation of the selected Asset is lower than the Strike price specified by the Client, the Transaction is considered profitable if the selected direction of the chart is “down.”  

5.1.2.5. The yield on the Transaction is fixed and depends on the selected amount of the Transaction, the Asset, Strike prices, the direction of movement of the chart, and the execution time of the Transaction.  

5.1.2.6. The income under the Transaction is defined as the percentage yield multiplied by the amount of the Transaction.  

5.1.2.7. The Transaction can be closed ahead of schedule. The price of early execution is calculated dynamically and updated depending on market conditions.  




1. **6. Order of Trading Operations**

6.1. The processing of the Client’s Trading Orders takes place in the following order:  

6.1.1. The Client submits a Trading Order, which is checked for correctness on the Trading Platform.  

6.1.2. The Client’s Trading Order is transmitted from the Trading Platform to the Server, where it is retested.  

6.1.3. After re-checking, the Trading Order is processed on the Server, and the result of processing is transmitted to the Trading Platform.  

6.2. The processing time of the Client's Trading Order depends on:  

6.2.1. The quality of communication between the Trading Platform and the Server.  

6.2.2. Market conditions.  

6.2.3. Under normal market conditions, processing time is usually 0–4 seconds.  

6.2.4. Under non-normal market conditions, the processing time may be extended.  

6.3. Opening Transactions  

6.3.1. The minimum amount of a Transaction on the Trading Platform is ₹30 / ৳30 or the equivalent of $0.5 (depending on the currency of the Account).  

6.3.2. The maximum amount of a Transaction is ₹10000 / ৳10000 or the equivalent of $100 (depending on the currency of the Account).  

6.3.3. A Client’s trading order for opening a Transaction is rejected if:  

6.3.3.1. The Client transferred the Trading Order before the first quotation of the Transaction Asset entered the Trading Platform.  

6.3.3.2. There are insufficient funds in the Client’s Account to open the Transaction.  

6.3.3.3. The Server rejects the order due to abnormal market conditions.  

6.3.3.4 When market conditions differ from normal, such as there is significant volatility or instability in the markets, or the industry as a whole, preventing us from providing our services in an orderly manner, including any instances where we are unable to receive data and/or we receive incorrect data from our service providers.

6.3.4. A Client’s trading order for opening a Transaction is deemed executed, and the Transaction is opened after the corresponding record appears in the Log File.  

6.4. Closing Transactions  

6.4.1. Transactions close at the current price of the Transaction Asset available on the Server at the time of closing the Transaction.  

6.4.2. A Client’s trading order for closing a Transaction is deemed executed, and the Transaction is closed after the corresponding record appears in the Log File.  

6.4.3. The Company may limit the maximum number of Transactions made by the Client in a specified period.  

6.4.4. The Company may change the percentage yield, the minimum and maximum Transaction amounts, and Expiration Periods for any or all Assets.  

6.5. Malfunctions  

6.5.1. Malfunctions in computer equipment, unstable Internet connections, interruptions in power supply, or hacking attacks may result in the invalidation of Transactions executed under these conditions.  

6.6. If there has been no trading on the Client's Account for 180 consecutive days, a monthly fee of $10 (or the equivalent amount in the account's currency) will be charged for account maintenance. This fee will not exceed the account balance and will be waived if trading activity resumes in the account.

1. **7. Procedure for Non-Trading Operations**

7.1. The official methods of depositing and withdrawing funds are the methods indicated on the Company's Website.  

7.1.1. The Client assumes all risks associated with using payment systems, including commissions from payment systems and/or providers for payments and currency conversion.  

7.1.2. The Company is not liable for delays or failures in payment processing due to payment system faults or provider issues.  

7.1.3. In case of complaints about payment systems or providers, the Client must contact the support service of the respective system or provider. The Client must also notify the Company of such complaints.  

7.2. Deposits:  

7.2.1. The Client must use the internal interface of the Website to replenish the Account.  

7.2.2. Minimum deposit amounts: ₹300/৳350 or $5 equivalent, subject to the Company's discretion in specific countries. The Company has the right to change the minimum deposit amount. The exact amount of the minimum deposit is displayed in the “Cashier” section of the Client’s personal Account.   

7.2.3. In some countries, the "Payment in 1 Click" service is available. The Company sets out the following terms and conditions for the use of this service:  

7.2.3.1. To activate this service the Client must check the box for "I want to save the wallet" when making a deposit.  

7.2.3.2. By using this service, the Client agrees to additional costs, taxes, and fees.  

7.2.3.3. Payments made through "Payment in 1 Click" are considered confirmed, processed, and irrevocably executed when the Client clicks the "Add funds in 1 click" button.  

7.2.3.4. By using the Service "Payment in 1 Click" the Client confirms he/she:

-&nbsp;is of legal age and owns the credit card used, 

-&nbsp;understands and accepts the risks and irrevocability of such payments,

-&nbsp;agrees not to cancel the payment or request withdrawal.  

7.2.4. To deactivate "Payment in 1 Click," the Client must uncheck the box for "I want to keep the wallet" during the next deposit.  

7.3. Withdrawals:  

7.3.1. Withdrawals are initiated by the Client through the internal Website interface.  

7.3.2. Minimum withdrawal amount: ₹1000/৳1000 or $15 equivalent, subject to Company discretion. The transfer of funds shall be determined by the Company’s financial counterparties and usually shall not exceed five to seven (5-7) days. The Company shall not be held responsible for any delays in the transfer of funds. 

7.3.3. The following withdrawal limits are valid on the Website: no more than ₹30000 / ৳25000 or an amount equivalent to $300 (depending on the currency of the Account) per day. Due to the peculiarities of individual withdrawals, these limits can be reduced. 

7.3.4. Withdrawals must use the same method and details as deposits. If not feasible, the Client must provide proof for alternative methods. The Company reserves the right to withhold withdrawal requests until all verification procedures are completed, including additional security checks or requests for documentation, to ensure compliance with AML and fraud prevention policies. 

7.3.5. The Company may withhold withdrawal requests for up to 10 business days for security reasons.  

7.3.6. The Company reserves the right to request verification documents (e.g., notarized IDs) for AML compliance. Failure to provide these may result in withdrawal refusals.  

7.3.7. The Company has the right to impose a limit on the withdrawal of funds equal to the amount of the Client's deposits over the past 30 (Thirty) days. This limit is implemented to comply with AML regulations and to ensure the legitimacy of funds. The Company reserves the right to conduct additional verification if required.

7.4. Additional Clauses:  

7.4.1. Fraudulent financial transactions can result in canceled transactions and account blocking.  

7.4.2. Deposits or withdrawals involving third-party payment details are prohibited.  

7.4.3. If the Client deposited into the account and subsequently decided to withdraw in whole or in part, but trading turnover is less than the deposit amount, a 20% fee is applied to withdrawals.  

7.4.4. Technical errors during financial transactions may result in canceled transactions and service results.  

7.4.5. The client is solely responsible for the accuracy and reliability of the data specified in the withdrawal application.

1. **8. Rights, Obligations, and Assurances of the Parties**

8.1. Client Rights:  

8.1.1. Submit requests for transactions, adhering to this Agreement. 

8.1.2. Submit complaints with relevant details to support@binany.com, with responses provided within three months or an extended timeline if necessary.  

8.1.3. Terminate the Agreement unilaterally under specified guidelines.

8.2. Client Obligations:  

8.2.1. Acknowledge activation of the Account upon deposit or advance payment.  

8.2.2. The Client shall maintain confidentiality of credentials and prevent unauthorized access: in the event of such occurrence, the Client shall inform the Company immediately and cooperate in restoring access to the Account. 

8.2.3. Update personal data within seven calendar days of changes.  

8.2.4. Hold only one account. If multiple Accounts are discovered, the Company reserves the right to cancel all transactions, block or terminate the Accounts, and withhold funds equivalent to any damage caused. The Client will not be entitled to claim any compensation for such actions.

8.2.5. Ensure compliance with applicable tax laws.  

8.2.6. Agree to the Company's right to amend the Agreement or Website materials, with changes deemed accepted unless objected to in writing.  

8.2.7. The Customer acknowledges and agrees to complete all KYC and other verification procedures required by the Company in accordance with Section 9 following the first deposit.

8.3. The Client confirms:  

8.3.1. Legal capacity, sound mind, and majority age.  

8.3.2. Compliance with applicable laws in the Client's jurisdiction.  

8.3.3. Funds used for transactions are legitimate and owned by the Client.  

8.4. Company Rights:  

8.4.1. Adjust obligations based on Agreement breaches.  

8.4.2. Change rates, limits, and conditions for assets or transactions.  

8.4.3. Contact the Client for clarifications.  

8.4.4. Unilaterally amend the Agreement or Website materials.  

8.5. Company Obligations:  

8.5.1. Provide Services if the Client adheres to the Agreement.  

8.5.2. Fulfill responsibilities outlined herein.


1. **9. Registration and Verification of the Client**

9.1. The registration procedure is mandatory for the Client.

9.1.1. To register on the Website, the Client must perform the following actions:

9.1.1.1. Enter an email address and password.

9.1.1.2. Select the currency of the Account. 

9.1.1.3. Accept the terms of the Agreement.

9.1.2. By accepting the terms of this Agreement, the Client warrants that he/she: 

9.1.2.1. Is an adult and legally capable. 

9.1.2.2. Has read and agreed to the terms of this Agreement.

9.2. Verification Process: 

9.2.1. To ensure the legality and security of services, the Company conducts identity verification. 

9.2.2. The Company may request the following documents: 

9.2.2.1. Copy of the Client’s passport data page with a photo and/or a copy of the front and back side of the ID card. 

9.2.2.2. Current utility bills, bank agreements, scanned copies of bank cards, or other documents to confirm the Client’s identity and information. 

9.2.3. Personal data is processed per the Company’s Privacy Policy. 

9.2.4. Verification is completed within 10 (ten) working days from submission of the required documents. This period may be extended to 30 (thirty) business days. 

9.2.5. If the Client unreasonably refuses to provide requested documents, the Company may suspend or block the Client’s Account.

9.3. Video Conference for Verification: 

9.3.1. The Company may request a video conference to confirm the Client’s identity. 

9.3.2. The Client must add the Company (support.binany) on Skype and prepare the required documents (passport and bank cards). 

9.3.3. The Company will notify the Client of the video conference at least 24 (twenty-four) hours in advance.

9.4. Communications from the Company: 

9.4.1. By registering, the Client consents to receiving emails, calls, and SMS messages from the Company. 

9.4.2. The Client may cancel subscriptions by: 

9.4.2.1. Clicking the “Unsubscribe” link in an email.

9.4.2.2. Contacting Customer Support.

9.5. Restrictions on Multiple Accounts:

9.5.1. The Client is allowed to register only one Account on the Website. 

9.5.2. If multiple Accounts are discovered: 

9.5.2.1. Transactions and financial results on all Accounts may be canceled.

9.5.2.2. Accounts may be blocked.

9.5.2.3. Funds in such Accounts will not be considered the Company’s financial liability to the Client.



1. **10. Non-Engagement with FATCA Reportable Persons**

10.1. The Company complies with the Foreign Account Tax Compliance Act (FATCA) and related U.S. tax regulations.

10.2. The Company does not provide services to any individual or entity identified as a FATCA Reportable Person.

10.3. The Company may request documentation to verify a Client’s FATCA status.

10.4. If a Client is identified as a FATCA Reportable Person, the Company may terminate the relationship without notice or liability.

1. **11. Indemnity and Liability**

11.1. The Client agrees to indemnify and hold the Company, including its directors, officers, employees, and representatives, harmless against all direct or indirect liabilities—such as losses, damages, claims, costs, or expenses—incurred by the Company or any third party due to any act or omission by the Client in fulfilling obligations under this Agreement or in the liquidation of any financial instruments to settle claims with the Company.  

11.1.1. This indemnification does not apply to liabilities resulting from the Company's gross negligence, willful default, or fraud and will remain effective even after the termination of this Agreement.  

11.2. The Company will not be liable for any direct or indirect losses, expenses, costs, or liabilities incurred by the Client in connection with this Agreement, except where such losses are due to the Company's gross negligence, willful default, or fraud.  

11.2.1. Regardless of section 16, the Company is not liable for loss of profit or any indirect or consequential losses arising in connection with this Agreement, whether due to negligence, breach of statutory duty, or other reasons.  

11.3. The Company holds no liability for any lost opportunity that might have increased the value of the Client’s financial instruments, nor for any decrease in their value, regardless of the cause, unless this loss is directly due to the Company’s gross negligence, willful default, or fraud.  

11.4. The Company is not liable for any loss due to misrepresentation, error in judgment, or any act or omission unless it is due to the Company’s gross negligence, willful default, or fraud.  

11.5. The Company shall bear no liability for any act or omission, nor for the insolvency of any counterparty, bank, custodian, or other third party that acts on behalf of the Client or through whom Client transactions are conducted.  

11.6. If the Company acts as an intermediary for Client transactions, the Client agrees and acknowledges that:  

11.6.1. Under certain market conditions at the time of execution or due to the risk management policies of a third-party market maker, the Company may need to cancel the Client’s trades or transactions and return the corresponding invested funds to the Client’s trading account balance. The Company will provide adequate notification in such cases.  

11.6.2. Should this occur, the Client waives any right, claim, or demand against the Company and agrees to indemnify the Company for any damage resulting from these actions. 

1. **12. Personal Data**

12.1. By agreeing to the terms and conditions of this Agreement, the Client irrevocably consents to the Company’s collection and processing of their personal data, provided manually by the Client, without the use of automated controls.  

12.1.1. For this Agreement, personal data includes the Client's name, surname, patronymic, gender, address, phone number, email, IP address, cookies, and any information related to the provision of Services (such as the Client’s trading history).  

12.2. The Client is required to provide accurate, correct, and complete personal data/information as requested by the Company.  

12.3. The purpose of collecting and processing personal data is to:  

12.3.1. Ensure compliance with applicable regulatory requirements, including anti-money laundering regulations.  

12.3.2. Fulfill all purposes related to this Agreement, such as enabling the Company to meet its obligations to the Client.  

12.4. The Client acknowledges and consents to the Company’s right to:  

12.4.1. Collect, record, organize, store, update, retrieve, use, share, anonymize, block, delete, and destroy personal data.  

12.4.2. Perform any other actions permitted by applicable regulatory legislation for the purposes stated above.  

12.5. The Client acknowledges and agrees that the Company will store, maintain, and process their personal data as described in this Agreement:  

12.5.1. Throughout the term of the Agreement.  

12.5.2. For at least seven years after any termination of the Agreement.  

12.6. The Client consents to the Company sharing their personal data with third parties and their representatives solely for purposes related to this Agreement:  

12.6.1. The amount of personal data disclosed will be limited to what is necessary to fulfill these purposes.  

12.6.2. The Company will ensure that any third party treats the data in compliance with relevant laws and regulations.  

12.7. The Company will not make personal data publicly available or disclose it for any purpose other than those required by applicable laws and regulations.  

12.8. In processing personal data, the Company will implement appropriate legal, organizational, and technical measures to:  

12.8.1. Safeguard it from unauthorized or accidental access.  

12.8.2. Protect against destruction, alteration, blocking, copying, distribution, or any other unlawful actions. 

1. **13. Assignment**

13.1. The Agreement shall be personal to the Client, and the Client shall not be entitled to assign or transfer any of his/her rights or obligations under this Agreement.

13.2. The Company may at any time assign or transfer any of its rights or obligations under this Agreement to a third party. The Company shall notify the Client of any such assignment.

1. **14. Risk Statement**

14.1. The Client is fully aware that the implementation of trading operations with financial instruments is accompanied by significant risks.  

14.1.1. Before using the Company's services, the Client needs to analyze his financial capabilities.  

14.2. Trading operations carried out by the Client through the Trading Platform are not transactions performed on the official exchange.  

14.2.1. These are over-the-counter transactions, which carry a greater risk for the Client than official exchange transactions.  

14.3. Any information and/or recommendations received by the Client:  

14.3.1. From the Website.  

14.3.2. From representatives or partners of the Company.  

14.3.3. Are not a direct offer to perform a trading operation or a financial transaction.  

14.4. The Client may incur financial losses as a result of:  

14.4.1. Malfunctions or failures in the operation of computer equipment, software, or an unstable Internet connection.  

14.4.2. Interruptions in power supply and other technical factors.  

14.5. In market conditions other than normal, the processing time for Trading Orders may be extended, potentially leading to losses.  

14.5.1. Sharp fluctuations in quotes may result in losses when a Transaction is executed at a price different from the price displayed in the Trading Platform.  

14.6. In some countries, the use of the Company's services may be restricted or prohibited by law.  

14.6.1. The Client assumes all risks associated with analyzing the legislation of his/her country or country of presence for such restrictions or prohibitions.  

14.6.2. The Client assumes responsibility for using the Company's services in countries where they are restricted or prohibited.  

14.7. The Client acknowledges that the Company does not guarantee:  

14.7.1. The receipt of profit by the Client in any amount.  

14.7.2. The lack of losses during the use of the Company’s services. 

1. **15. Charges and Fees**

15.1. The Company shall be entitled to receive a fee from the Client regarding the Service(s) provided by the Company.  

15.2. The Company may pay fees/commissions to business introducers, referring agents, or other third parties based on a written agreement.  

15.2.1. This fee/commission is related to the frequency/volume of transactions and/or other parameters.  

15.3. All applicable fees or charges can be found on the Company’s Website.  

15.3.1. The Company has the right to amend its fees and charges from time to time.  

15.4. Ongoing trading fees, including but not limited to swaps, shall be charged and deducted from the Client’s account balance.  

15.4.1. If the Client does not maintain sufficient funds in his/her balance, the relevant position subject to swap will be closed by the Company.  

15.5. The Client agrees that any amounts sent by the Client will be deposited to the Account at the value on the date of the payment received and net of any charges/fees charged by the bank or any other intermediary involved in such transaction process.  

15.5.1. In any other case, the Client shall authorize the Company to withdraw the fee by way of transfer from the Client’s Account.  

1. **16. General Limitation of Liability**

16.1. Company’s Warranties and Responsibilities

16.1.1.The Company does not guarantee uninterrupted service, immunity from unauthorized access, or error-free operations.

16.1.2. The Company is not liable for third-party actions, force majeure events, or damages beyond its control.

16.1.3. Under no circumstances shall the Company or its agents be responsible for direct or indirect damages.

16.1.4. The Company is not a credit institution, does not engage in banking activities, and does not accept funds from individuals on repayment, payment, or term deposit basis. It does not open or maintain bank accounts

16.1.5. The Company shall not be liable for any failure to fulfill obligations or losses suffered by the Client due to hacker attacks, system malfunctions (whether on the Client’s or Company’s end), or data transmission failures beyond the Company’s control.

16.1.6. The Company is not liable for any losses incurred by the Client due to force majeure events, including but not limited to: natural disasters, man-made accidents, military actions, terrorist acts, uprisings, civil unrest, strikes, and other similar events beyond the Company's control.

16.1.7. The Client acknowledges that the Company reserves the right to accept or decline any deposit and/or funding and/or withdrawal request by the Client depending on the payment method that the Client chooses (which includes but is not limited to the third-party financial institution from which the Client wishes to deposit/withdraw funds with the Company (“Third-Party Institutions”)). The Company may suggest an alternative for the Client’s request.

16.1.8. The Company does not have and cannot in any way have any control over such Third-Party Institutions and any transactions made by the Client through the Platform using such institutions. It is hereby acknowledged and agreed that the Company shall bear no liability, monetary or otherwise, in relation to any loss of funds incurred by the Client pursuant to any actions or omissions of Third-Party Institutions.

16.1.9. The Company is not responsible for any actions or inactions by the Client while using the Company’s services, nor for any losses resulting from the execution of Transactions via the Trading Platform.

16.1.10. Without limitation of the aforesaid, and only in the event of a definitive judgment by a court or other authorized legal institution resolving that the Company and/or its Agent(s) hold liability towards the Client or a third party, the Company's liability, in any event, will be limited to the amount of money deposited by the Client, excluding funds derived from trading activities. The Company is not liable for amounts resulting from trading activities that exploit system vulnerabilities, errors, or fraudulent actions by the Client.

16.2. Client Warranties and Responsibilities

16.2.1. The Client guarantees that by using the Company’s services:

16.2.1.1. Transactions are entered into exclusively in the Client's own name and interest.

16.2.1.2. The Client is not a citizen or resident of any country where the Company does not provide services.

16.2.1.3. The Client does not use anonymizers, VPNs, or other methods to obscure their real IP address and location.

16.2.2. The Client is responsible for the authenticity and validity of any documents submitted during verification. If false or invalid documents are provided, the Company may refuse service, block the Client’s Account, and withhold any funds equivalent to the Company’s actual damage. The Company reserves the right to refuse re-registration.

16.2.3. In compliance with international law, the Client affirms that any funds deposited into the Account are not derived from illegal activities such as drug trafficking, kidnapping, or other criminal activities. The Client agrees not to use the Platform for money laundering or illegal activities. The Company may refuse service, block or close the Client’s Account, and withhold funds if AML laws are violated. The Company also reserves the right to report suspicious activities to authorities.

16.2.4. The Client agrees to provide necessary documentation and cooperate with the Company to comply with AML international legislation.

16.2.5. The Client acknowledges that actions performed by the Client or third parties with the Client’s participation that destabilize the Website, equipment, software, or services may lead to the Company refusing service to the Client’s Account without the right to withdraw profits. The Company may withhold funds equivalent to the damage caused by such actions and reserves the right to refuse to re-register the Client.

16.2.6. The Client is fully responsible for the security of login credentials for accessing the Account. The Client must prevent third-party access to the Account. If unauthorized access occurs, the Client must immediately notify the Company. The Client assumes responsibility for any losses related to restoring Account access, aside from the provision of new login credentials following additional identification.

16.2.7. The Client is solely responsible for verifying that all transactions and services received are not contradictory to any applicable law and for undertaking any other legal duty emanating from the use of the Website at the Client’s sole option, discretion, and risk. The Client is responsible for ascertaining whether it is legal in the Client's jurisdiction and/or place of residence.

16.2.8. The Client holds sole liability for all transactions in their Trading Account, including all card transactions or other means of deposit and withdrawal transactions.

1. **17. Effect, Amendment, and Termination of this Agreement**

17.1. This Agreement enters into force at the time of the Client's registration on the Website. 

17.2. The obligations and rights of the Client and the Company established by this Agreement are considered a long-term act and remain valid until the termination of the Agreement. 

17.3. The Company has the discretion to amend this Agreement at any time. 

17.3.1. Amendments will come into force upon posting the updated Agreement text on the Website, unless a different effective date is specified. 

17.4. If the Client does not agree with the amended Agreement: 

17.4.1. The Client must stop using the Company's services. 

17.4.2. The Client must block their Account through the interface in the Personal Account on the Website or by contacting the Company's Customer Support Service, after withdrawing funds from the Account. 

17.5. This Agreement may be terminated under the following circumstances: 

17.5.1. At the initiative of either Party. 

17.5.2. In the event of the Client's death or legal incapacitation. 

17.5.3. In the case of the Company’s liquidation. 

17.6. Regardless of the basis for termination, the Company is obliged to fulfill its financial obligations to the Client, which are limited to the return of the Client’s deposited funds, excluding any amounts derived from trading activities, bonuses, or fraudulent actions, as outlined in this Agreement. The Company reserves the right to deduct any losses incurred by the Company due to the Client’s actions, including but not limited to the exploitation of system vulnerabilities, fraudulent activities, or violations of this Agreement, from the refundable amount.

17.7. This Agreement may be terminated by either Party at any time, for any reason. In the event of termination, the Client is obligated to settle all outstanding fees and charges due to the Company. Termination of this Agreement does not release the Client from fulfilling any obligations incurred prior to termination or from liability for any breach of the Agreement.

17.7.1. To terminate the Agreement unilaterally, the Client must block their Account through the interface in the Personal Account on the Website or by contacting the Company's Customer Support Service, after withdrawing funds from the Account. 

17.8. If the Client requests the Company to unlock their Account or restore an archived Account: 

17.8.1. This Agreement will renew in the version valid at the time of the unlocking or restoration of the Account. 

1. **18. Complaints and Dispute Resolution**

18.1. In case of a disputable situation, the Client must first contact the Company's Customer Support Service using the contacts specified in section 20 of this Agreement. 

18.2. If the answer provided by the Support Service is deemed unsatisfactory by the Client, or if the Support Service lacks the authority to resolve the issue, the Client may: 

18.2.1. Request that the issue be forwarded to the Company’s Dispute Resolution Department. 

18.2.2. Send the complaint via email to support@binany.com or via online chat on the Website.

18.3. When submitting a complaint, the Client must provide the following information: 

18.3.1. Full name of the Client. 

18.3.2. Client's email address. 

18.3.3. Date and details of the operation(s) under dispute. 

18.3.4. A detailed description of the situation. 

18.3.5. Files supporting the complaint, if available. 

18.4. Complaints may not be considered if: 

18.4.1. The complaint includes provocative statements, unfounded accusations, or threats to damage the Company’s business image. 

18.4.2. The received message contains threats, insults, or obscene language directed at the Company or its employees. 

1. **19. Taxes**

19.1. The Company is not a tax agent and does not provide data on the Client’s operations to third parties. 

19.2. Such information will only be provided to competent state authorities upon receipt of an official request. 

1. **20. Contacts**

20.1. To contact the Company, the Client can use the following methods: 

20.1.1. Email: support@binany.com 

20.1.2. Online chat on the Website. 

20.2. The Client’s contact information is considered to be: 

20.2.1. The email address provided during registration on the Website. 

20.2.2. The phone number indicated in the Personal Account on the Company’s Website (if the Client chooses to provide one). 

20.3. The Company is not responsible for incorrect contact information provided by the Client on the Website. 


### **Annex 1- General Terms Technical Regulation**

1.1.&nbsp;The Client acknowledges that these General Terms are an integral part of this Agreement. It is the Client's responsibility to verify that all transactions and Service(s) received are not contradictory to any applicable law and to undertake any other legal duty emanating from the use of the Website at the Client’s sole option, discretion and risk, and the Client is solely responsible for ascertaining whether it is legal in the Client's jurisdiction and/or place of residence. The Client holds sole liability for all transactions in his Trading Account, including all card transactions or other means of deposit and withdrawal transactions (as stated below). The Client acknowledges that the Company reserves the right to accept or decline any deposit and/or funding and/or withdrawal request by the Client depending on the payment method that the Client chooses (which includes but is not limited to the third party financial institution from which the Client wishes to deposit/withdraw funds with the Company (Third-Party Institutions), and the Company may suggest to the Client an alternative for its request. It is important to note that the Company does not have and cannot in any way have any, control over such Third-Party Institutions and any transactions made by the Client through the Platform using such institutions, and it is hereby acknowledged and agreed that the Company shall bear no liability, monetary or otherwise, in relation to any loss of funds incurred by the Client pursuant to any actions or omissions of Third-Party Institutions.

1.2.&nbsp;The Client is responsible for securing his/her Username and Password for his Trading Account. The Client holds sole responsibility for any damage caused due to any act or omission of the Client causing inappropriate or irregular use of the Client Trading Account.


1.3.&nbsp;It is clearly stated and agreed by the Client that the Client bears sole responsibility for any decision made and/or to be made by the Client relying on the content of the Website and no claim and/or suit of any kind will arise to that effect against the Company and/or its directors and/or employees and/or functionaries and/or Agents (the Company and/or its Agents). The Company and/or its Agents will hold no responsibility for loss of profits due to and/or related to the Website, Transactions carried out by the Client, Services and the General Terms of use or any other damages, including special damages and/or indirect damages or circumstantial damages caused, except in the event of malicious acts made by the Company.


1.4.&nbsp;Without limitation of the aforesaid and only in the event of definitive judgment by court or other authorized legal institution resolving that the Company and/or its Agent(s) hold liability towards the Client or third party, the Company's liability, in any event, will be limited to the amount of money deposited and/or transferred by the Client to the Trading Account in respect of the transaction which caused the liability of the Company and/or its Agent(s) (if such was caused).


1.5.&nbsp;No Trading Account will be approved without the completion of the Company’s compliance procedures, including the identification and verification of the Account.


1. **2. Risks**


2.1.&nbsp;The value of the Financial Instruments offered by the Company may increase or decrease. The Client acknowledges that they fully understand the risks involved in trading CFDs (and other similar products), including, but not limited to, the risk of loss of all funds.


2.2.&nbsp;CFD Trading does not give you any right to the underlying instrument of the Transaction. This means that you do not have any interests in, or the right to purchase, any underlying shares in relation to such instruments because the CFDs represent a notional value only.


2.3.&nbsp;The Client acknowledges that he has read, understood and accepted the Company’s risk disclosure information found on the Company’s Website.


2. **3. Financial Information**


3.1.&nbsp;The Company should not be held responsible for any losses that the Client may incur (or to a third party) due to reliance on inaccurate or erroneous financial information on the Website.

3.2.&nbsp;The Client should verify the accuracy and reliability of the information on the Website and its appropriateness in comparison with other dependable information sources. The Company will not be held responsible for any allegedly caused claim, cost, loss or damage of any kind as a result of information offered on the Website or due to information sources used by the Website.

3.3.&nbsp;The Client approves and accepts that any oral information given to him/her in respect of his Trading Account might be partial and unverified. The Client accepts sole risk and responsibility for any reliance on the aforementioned information. The Company does not give any warranty that pricing or other information supplied by it through its trading software or any other form is correct or that it reflects current market conditions.


3. **4. Quotes**

4.1.&nbsp;The Client acknowledges that when using the Company's services, the only reliable source of information about Quotes flows is the Server of the Company. Quotes displayed on the Trading Platform cannot serve as a reliable source of information on Quotes flows, as in the case of an unstable connection between the Trading Platform and the Server, some Quotes from the flows may not reach the Trading Platform.

4.2.&nbsp;Charts displayed in the Trading Platform are indicative. The Company does not guarantee that the Transaction will be completed at the Quotation indicated on the chart in the Trading Platform at the time the Client submits the Trading Order.

4.3.&nbsp;The price of an Asset in the Trading Platform is determined by the formula (purchase + sale) / 2.

4.4.&nbsp;If the Client’s Trading Order was executed at a non-market Quotation, the Company corrects the financial result of the Transaction in accordance with the Market Quotations at the time of execution of such Trading Order or cancels the result of the Transaction.


4. **5. Bonuses and gifts, participation in tournaments and promotions.**

5.1.&nbsp;Bonuses are credited to the Customer’s Account in accordance with bonus or promotional programs conducted by the Company.


5.2.&nbsp;The amount of the Bonus depends on the conditions of the promotion or program within which it is credited (no deposit Bonuses), and / or the size of the Client's Deposit (deposit Bonuses).


5.3.&nbsp;The Company reserves the right to cancel bonuses or their related profits if fraudulent activities or abuse of trading systems are detected. Bonuses and profits derived from them may not be withdrawn until all terms and conditions of the bonus program are met, and trading activity is verified as compliant.


5.4.&nbsp;Bonuses credited to the Account are not a financial obligation of the Company to the Client.


5.5.&nbsp;After the Bonus is activated, the funds in the Client's Account become available for Withdrawal only after the Client completes the Obligatory Trade.


5.6.&nbsp;Obligatory turnover is the bonus amount multiplied by his shoulder. If the Bonus shoulder is not specified, then for Bonuses that are less than 50% of the Deposit size when using the Bonus, the shoulder should be considered equal to 35, and for Bonuses that are 50% or more of the Deposit size when using the Bonus, the shoulder should be considered equal to 40. The sum of each Transaction taken into account in the Obligatory trade turnover is directly proportional to the yield on the Asset of such a Transaction.


5.7.&nbsp;Transactions in the standard trading mechanics with a zero result in the Compulsory Trading Circuit are not counted.


5.8.&nbsp;Transactions in the Trading Mechanics “Strike” are not taken into account in the Compulsory Trading turnover.


5.9.&nbsp;Within the framework of one share, the Client is entitled to receive Bonus funds only once, unless otherwise specified in the terms of the share.


5.10.&nbsp;The profit received by the Client for Transactions using Bonuses may have limitations on the amount of Withdrawal. The maximum amount of Withdrawal of profits received using gift no deposit Bonuses sent to the Customer's email is $50 / €50 or equivalent to $50 (depending on the currency of the Account).


5.11.&nbsp;Gift No Deposit Bonuses must be activated in the Client’s Personal Account within 3 (Three) days from the moment of their accrual. If within 5 (Five) days from the date of activation of the Bonus the Obligatory trade is not made or the Deposit is not made to the Account, the Bonus is reset.


5.12.&nbsp;After the Bonus is activated, the Client is entitled to cancel it by contacting the Company's Customer Support Service using the contacts specified in section 12 of this Agreement. Refusal of the Bonus or its cancellation is possible only if there are no Trading Operations of the Client since the moment of accrual of Bonuses.


5.13.&nbsp;Upon expiration of the promotion, the Bonus accrued under such an action may be debited from the Client's Account.


5.14.&nbsp;A client can have only one active Bonus on his Account. If the Client already has an active Bonus on the Account, he cannot activate one more until the Mandatory trade on the already active Bonus is completed.


5.15.&nbsp;If the Client's Account Balance falls below the minimum allowable size of the Transaction, the Bonus is reset.


5.16.&nbsp;If the Client's Account has been transferred to the archive in the manner provided for by this Agreement and there is an active Bonus on the Client's Account, the Bonus is reset.


5.17.&nbsp;The client has the right to participate in all available for him tournaments and promotions held by the Company. The Client must independently familiarize himself with the conditions of such tournaments and promotions posted on the Company's Website.


5.18.&nbsp;Tournaments are not available for Trading Strike Mechanics.


5.19.&nbsp;The funds received by the Client from the Company as a prize for participation in the tournament are credited to his Real Account after the prize is activated in the Client’s Personal Account, unless otherwise specified in the tournament conditions.


5.20.&nbsp;If the Security Service of the Company suspects the Client of fraudulent actions in order to win a tournament or a promotion, the Company has the right to review or cancel the Customer’s results in such a tournament or promotion, as well as to refuse to participate in subsequent tournaments and / or promotions. In the event that the fact of fraud is confirmed, the results of the Client in the tournament or promotions are canceled.


5.21.&nbsp;As part of promotions or special programs, the Company may provide additional gifts for the Client.


5. **6. Copyright**


6.1.&nbsp;Copyrights and Intellectual Property (IP) on the Website are the Company's property or of third parties which have authorized the Company to use such IP on the Website and Service(s). It is forbidden to copy, distribute, duplicate, present in public, or deliver the copyrighted material, in whole or in part, to third parties. It is forbidden to alter, advertise, broadcast, transfer, sell, distribute or make any commercial use of the copyrighted material, in whole or in part, except with duly signed prior permission from the Company.


6.2.&nbsp;Unless explicitly stated otherwise, any material and/or message, including without limitation, idea, knowledge, technique, marketing plan, information, questions, answers, suggestions, emails and comments (hereinafter – “**Information**”) delivered to the Company shall not be considered the Client's confidential or proprietary right of. Consent to the Agreement will be considered as authorization to the Company to use the entire Clients' Information (excluding Clients' Information designated for personal identification), at the absolute and sole discretion of the Company without requirement of any additional permission from the Client and/or the payment of any compensation due to such use.


6.3.&nbsp;The Client undertakes that any notice, message or any other material supplied by the Client shall be appropriate and shall not harm other persons, including their proprietary rights. Client shall refrain from uploading or sending any illegal and/or harmful and/or disturbing to other Clients material, and is strictly forbidden from taking any action, which might damage the Company.


6. **7. Content and Third Parties’ websites**


7.1.&nbsp;The Website might include general information, news, comments, quotes and other information related to financial markets and/or advertising. Some information is supplied to the Website by unaffiliated companies.


7.2.&nbsp;The Company does not provide investment research. All news, comments, quotes and other information related to financial markets published by the Company are of a promotional/marketing nature only.


7.3.&nbsp;The Company does not prepare, edit or promote the information/links and/or other information provided by unaffiliated companies.


7.4.&nbsp;The Company will not be liable for the content of any third-party websites or the actions or omissions of their proprietors, nor for the contents of third-party advertisements and sponsorship on those websites. The hyperlinks to other websites are provided for information purposes only. Any Client and/or potential client uses any such links at his/her own risk.


7. **8. Processing of Client Orders to Open Positions**


8.1.&nbsp;If the amount of available funds is sufficient to open a position, the position will be opened.


8.2.&nbsp;If the size of the available funds is insufficient to open a position, the position will not be opened.


8.3.&nbsp;The Client’s order to open a position is processed, and the position is opened only after the corresponding entry in the server log file. Each new position is assigned with a serial number.


8. **9. Processing of Client Orders to Close Positions**

9.1.&nbsp;Closing of trading positions occurs at the current price at the trading server at the moment of closing of the trading operation.



9. **10. OTC Assets**


10.1.&nbsp;An OTC Asset or “over the counter” is an asset that is traded out of the regular market (hereinafter referred to as the “**Asset**”).


10.2.&nbsp;The Asset’s price is formed from data for trade requests and orders of the Clients, received by the Company.


10.3.&nbsp;The Client acknowledges that by making trade requests and orders on such Asset, he/she understands the essence of the work of such an Asset and the pricing algorithm of the Asset.


10.4.&nbsp;   The Client acknowledges that by making trade requests and orders on such Assets, he/she admits that the only reliable source of quoting information is the main server for the trade orders of the Clients.


10. **11. Fraud**


11.1.&nbsp;In the event that the Company has reasonable suspicion to believe and/or comes to its attention that the Client has acted fraudulently with regard to the subject matter of the Agreement, including without limitation to the following occurrences:


11.1.1.&nbsp;Fraud associated with credit card transactions and other ways to fill a balance that does not belong to the Client;


11.1.2.&nbsp;Fraud associated with the use of software for false trading results;


11.1.3.&nbsp;Fraud associated with errors and system failures for false trading results,


11.2.&nbsp;The Company shall be entitled to block the Client's account without prior notice and without the possibility of further money withdrawal, and/or entitled to unilaterally terminate the Agreement in the extrajudicial procedure.


11. **12. Benefits**

12.1.&nbsp;The Company may provide benefits to clients, including but not limited to, VIP status, tournaments and/or other privileges (“**Benefits**”), at its absolute discretion and subject to fulfilling the required conditions.

12.2.&nbsp;The Client acknowledges and accepts:


12.2.1.&nbsp;The Company reserves the right, without prior notification, to amend or cancel any of the Benefits provided at any time for any reason;


12.2.2.&nbsp;Conditions are subject to change at any time and may vary depending on each region;


12.2.3&nbsp;It is prohibited to abuse any of the privileges provided by the Company (e.g. creating multiple trading accounts to claim these Benefits);


12.2.4&nbsp;The client may submit a request to support@binany.com to stop receiving such Benefits at any time.


12. **13. Foreign Exchange**


13.1.&nbsp;For any conversion required to be effected from one currency to another for the execution of any order, the Company is entitled at its absolute discretion to debit the Client’s Trading Account with the equivalent amount of the transaction in the currency in which the Client holds the Trading Account.


13.2.&nbsp;The Client acknowledges and agrees that he shall undertake all risks deriving from any such conversion and, in particular, the risk of loss which may be incurred as a result of the fluctuation in the exchange rates.`

export const PrivacyPolicy = `
### **Privacy Policy**

BINANY values your privacy and is committed to safeguarding your personal data. This privacy policy explains how we collect and handle personal information—specifically, data about a Client (as defined below) who is a natural person and can be identified from this information (hereinafter referred to as "data")—in line with applicable data protection laws and best practices. 

This Privacy Policy is designed to provide clear information on how we collect, use, and protect your data in compliance with the General Data Protection Regulation (GDPR) and other applicable data protection laws. We strive to uphold the highest standards of data protection, ensuring transparency and respecting your rights as outlined in GDPR.

We aim to establish one of the most secure infrastructures among brokers worldwide. Through this privacy policy, we explain why you can trust us with your data and feel assured that it is safe.

It is important that you read this privacy policy together with any other privacy notices we may provide on specific occasions when we collect or process your data. This will ensure you are fully informed about how and why we use your information.

In this Privacy Policy, unless the context requires otherwise, terms defined herein shall carry the meanings assigned to them in the Terms & Conditions.

Please note that this Privacy Policy is intended for Clients and potential customers. If you are a BINANY employee, contractor, or service provider, your personal information will be managed in line with your employment contract, service agreement, or our separate policies, which are available upon request through the contact details listed in the section OUR CONTACT DETAILS below.

If you are participating in our affiliate and/or introducing broker programs, we will process the data provided under our agreement with you to fulfill our rights and obligations under that agreement. In this case, the term "Client" in this Privacy Policy also includes "Affiliate" and/or "Introducing Broker" as applicable.



1. **1. ABOUT US**

BINANY is a global brand, which is operated by Finpulse LLC. This includes its affiliated and related entities (collectively referred to as “We,” “Company,” or “BINANY”). We act as the data controller, responsible for the personal information provided by Clients when they register for a Trading Account, Demo Account, or use any of our other services offered through our website (the “Website”), which includes both desktop and mobile versions.

This Privacy Policy is issued on behalf of BINANY, which is accountable for collecting and processing your data when you use our Trading Platform via the Website for a Trading Account or Demo Account. We respect your privacy and are committed to protecting any data we collect, use, or access in the course of providing services.

We take proactive steps to implement strong data protection practices and regularly update these measures to ensure the security of Client data and accounts. Your data is safeguarded by legal, administrative, and technical protocols designed to uphold privacy, integrity, and accessibility. To prevent potential security incidents involving your data, we use a combination of organizational and technical measures, informed by annual risk assessments.

We will not disclose any private information about our Clients or former Clients unless we have written authorization from the Client, it is required by law, it is necessary to verify the Client's identity, or it is essential to fulfill our contractual obligations under any agreement with the Client. The information of Clients is processed exclusively by our employees or trusted third-party providers, who deliver specific services essential for our operations. All data is stored on electronic and physical media in compliance with applicable laws.

2. **2. HOW WE USE YOUR DATA**

Our processing of your personal data relies on one or more legal bases as outlined in Article 6 of the GDPR, including: (a) your consent, (b) the need to perform a contract, (c) compliance with legal obligations, (d) protection of vital interests, (e) performing a task in the public interest, and (f) our legitimate interests, provided they do not override your fundamental rights and freedoms.

2. 1.&nbsp;We may collect, use, store, and share various types of data about you, categorized as follows:

-&nbsp;Identity Data: Includes details such as your first name, last name, patronymic (if applicable), date of birth, gender, passport or ID number, driver's license, and a copy of your photo.

-&nbsp;Contact Data: Includes billing address, email, and phone numbers.

-&nbsp;Financial Data: Contains bank account information, payment card details, and tax identification numbers (such as social security number, income tax identification number, or national insurance number).

-&nbsp;Transaction Data: Covers details about your transactions, payments, withdrawals, exchanges, trading history, profit, balance, deposit and withdrawal amounts, methods, and any other specifics related to services accessed on our Website.

-&nbsp;Technical Data: Encompasses IP address, login data, browser type and version, time zone, location, browser plug-ins, operating system, device details, and other technologies used to access the Website, including cookies.

-&nbsp;Profile Data: Involves Client Account details like username, password, transaction history, interests, preferences, feedback, and survey responses.

-&nbsp;Usage Data: Includes information on how you use our Website, products, and services, such as registration date, account type, trading cluster, complaint and request history, and IP log.

-&nbsp;Marketing and Communication Data: Reflects your preferences for receiving marketing and communication updates from us.

-&nbsp;Special Categories or Sensitive Data: Includes details on religious beliefs, annual income, biometric data, and any criminal convictions or offenses.

-&nbsp;Conformity Data: Contains information on your education, employment status, trading experience, and results from self-assessment tests.

-&nbsp;Banking Data: Comprises information about your payment methods, such as bank card issuer details, card number, cardholder name, expiration date, payment system, card validation code (CVV2/CVC2), and card photos.

-&nbsp;KYC (Know Your Customer) Data: Includes documents verifying identity, such as recent utility bills, ID card, passport, and driver's license copies.

-&nbsp;Economic Profile Data: Covers occupation, investment purposes, annual income, net wealth, expected annual investment, and sources of funds.

-&nbsp;Location Data: Details your location when interacting with our Website, based on parameters like country, time zone, and language settings.

-&nbsp;Audio Data: Includes recordings of calls made to or received from us.

2. 2.&nbsp;Aggregated Data consists of statistical or demographic data derived from your information, which doesn’t reveal your identity directly or indirectly. For example, aggregated Usage Data helps us analyze user engagement with website features.

If we combine Aggregated Data with personal data in a way that could identify you, we treat it as personal data according to the terms of this policy.


We handle your data in a lawful, fair, and transparent way, adhering to principles of purpose limitation, data minimization, accuracy, storage limitation, integrity, confidentiality, and accountability.

Generally, we collect and process your data for the following reasons:

1.&nbsp;To fulfill our contract with you;

2.&nbsp;To meet our legal obligations, including anti-money laundering and counter-terrorism laws;

3.&nbsp;To protect our legitimate interests.

Clients agree that we may retain data on their account and transactions in case of a dispute with BINANY.


It is the Client's responsibility to update any changes to the data provided. While we make efforts to keep your data up-to-date, it is essential that you assist in notifying us of any updates. Clients acknowledge that BINANY holds no obligation for independently verifying or reviewing data.

3. **3. WAYS WE COLLECT YOUR PERSONAL DATA**

We are committed to transparency in our data processing practices in compliance with Articles 12, 13, and 14 of the GDPR. This means providing you with clear information on our data collection methods, purposes of processing, categories of personal data collected, legal grounds for processing, data recipients, and retention periods.


We use various methods to collect data from and about you, including:


**Personal Data Provided Directly:** You provide us with Identity, Contact, and Financial Data through our Website by filling out forms or communicating with us via email or other methods. Examples of instances when you may submit data include:

-&nbsp;Registering for a Trading or Demo Account;

-&nbsp;Subscribing to publications or updates;

-&nbsp;Requesting marketing materials and promotions;

-&nbsp;Entering competitions, promotions, or surveys;

-&nbsp;Providing feedback or contacting us.

This data collection allows us to deliver our services effectively and fulfill our legal obligations, including fraud prevention and compliance with anti-money laundering regulations. If you do not provide the required data, we may be unable to perform the contract with you, which could lead to service cancellation. We will inform you if this is the case. It is important to keep your information accurate and up-to-date throughout your relationship with us.

**Automated Technologies or Interactions.** When using our services, your device automatically sends us technical data, including your location settings (e.g., country, time zone, language). Information like IP address, cookies, browser type, operating system, access times, and page requests helps us optimize our platform's performance, including mobile and desktop versions. We also use web analytics to track website performance and monitor user behavior, which enables us to improve our services. You may request that we restrict certain data transmissions (within legal limits) by contacting our Data Protection Officer (DPO) using the registered email on your account. We will address your request within 30 business days.


**Information About Cookies:** 


Cookies are small data files with unique identifiers sent from a website to your device's browser, which are stored on your device’s hard drive to track website usage. Websites commonly use cookies to track online traffic and user activity. When you visit our Website, we may collect information such as browser type, IP address, and referring websites via cookies.


Cookies allow us to understand the Client’s journey on our Website, anonymously identify returning users, and determine popular content. We ensure your privacy by not storing personal details, names, or emails in cookies. The use of cookies is standard practice among major websites and enables us to optimize the site experience for Clients by learning which content is most useful. You can disable cookies or delete them manually, though this may limit some functionality on our site.

4. **4. REASONS FOR USING YOUR DATA AND LEGAL GROUNDS**

We process the above-mentioned data in compliance with current legislation, allowing us to (i) meet our contractual obligations to the Client, (ii) deliver our services effectively, (iii) comply with legal requirements, including fraud prevention and anti-money laundering laws, and (iv) protect both our legitimate interests and your vital interests.

The legal grounds for processing data are as follows:

a. To comply with our legal obligations;

b. To fulfill our contractual commitments to the Client; 

c. To protect our legitimate interests where your fundamental rights do not override these interests;
    
d. Based on your consent, when applicable.

We process your personal data in compliance with applicable laws and regulations for the following purposes:

-&nbsp;Client Onboarding and Communication

We use your data to register you as a Client, communicate important updates such as changes to terms or policies, provide secure identification and support services, and verify that you meet the legal age requirements of your jurisdiction. These activities are necessary to fulfill our contractual obligations to you and to comply with legal requirements.

-&nbsp;Risk Assessment and Client Profiling

Your information is used to evaluate risk levels through scoring processes, helping us determine your financial or operational risk profile. This processing is required to fulfill our contractual commitments and to comply with regulatory obligations.

-&nbsp;Geolocation Validation

We process your location data to verify geographic details as required for regulatory and legal purposes. This ensures compliance with applicable laws and helps us meet the requirements of our contract with you.

-&nbsp;Authentication and Social Network Integration

Your data may be processed through social network protocols and account connections to facilitate secure authentication, identification, and support services. This is necessary to meet the requirements of our contract and to ensure compliance with security and legal standards.

-&nbsp;Transaction Processing

Your data is processed to manage and fulfill transactions such as deposits, trades, and withdrawals, oversee payments and charges, and recover debts where applicable. This is essential to fulfill the services outlined in our contract and to protect our legitimate interests, such as ensuring financial accountability.

-&nbsp;Platform Security and Business Administration

To maintain and secure our platform, we process your data for tasks such as troubleshooting, IT system management, fraud prevention, and compliance monitoring. This processing is necessary to fulfill our contract with you and to meet operational and legal obligations.

-&nbsp;Service Optimization and Advertising

Your data is used to deliver personalized content and advertisements, enhance user experiences, and assess the effectiveness of marketing efforts. These activities are critical to providing the services detailed in our contract and are aligned with our legitimate business interests, including improving usability and expanding offerings.

-&nbsp;Product Development and Marketing Strategy

We analyze your interactions with our services to refine and develop our products, grow our business, and inform our marketing strategies. This is part of our commitment to improving services while meeting the obligations outlined in our contract.

-&nbsp;Informational Updates

Your data is processed to notify you of new products, features, or services, ensuring you are kept informed about relevant developments. This processing is necessary to fulfill the terms of our contract and supports our legitimate business interests in keeping you updated.

-&nbsp;Direct Marketing and Communication

We may use your data to send direct marketing materials, newsletters, and updates about our services while ensuring your information is never shared for third-party promotions. This helps us deliver relevant, personalized communications as part of our contract and aligns with our legitimate business interests.

-&nbsp;Employee Training and Dispute Resolution

We process your data to train our employees, monitor performance, and address disputes effectively. This helps us meet the terms of our contract and supports legal obligations related to fraud prevention and dispute resolution.

-&nbsp;Regulatory and Financial Verifications

Sensitive data such as income or criminal history may be processed to confirm compliance with financial and legal requirements. These measures are necessary to meet regulatory obligations and safeguard your vital interests.


If you are a current Client, we may use your data to communicate support updates, newsletters, or event details relevant to our services. Additionally, if you consent, we may send you marketing materials about our services via email or other channels.


Our Website is intended for users over the age of 18; therefore, we collect your birthdate to verify age eligibility.

5. **5. HOW TO OPT OUT**

Feel free to email us at support@binany.com, requesting us to stop sending marketing communications or sharing data with third parties. We will fulfill your request within seven business days.

6. **6. SHARING YOUR INFORMATION**

**We may share your data with third** **parties** for the purposes outlined in this policy. We take all necessary steps to ensure that third-party service providers do not use your data for their own purposes, allowing them to process it only for specified tasks and in line with our instructions.


In general, your data is shared with our processors. Additionally, we may transfer your data to another legal entity in the event of a business reorganization, sale, merger, or similar restructuring.


For sharing data outside of our affiliated entities, we maintain strict confidentiality and only disclose client-related information if:

1.&nbsp;It is legally required;

2.&nbsp;You explicitly request or authorize us to process a transaction or perform a service;

3.&nbsp;It is necessary for service provision under our contractual relationship;

4.&nbsp;It is required to protect our legitimate interests under applicable laws.


**Sharing Your Information with External Parties.**


Your personal data may be shared with external entities in the following scenarios:

-&nbsp;**Service Providers**

We may collaborate with reliable third-party partners to perform critical operations on our behalf. These include managing and supporting IT systems, processing payments, conducting data analysis, providing marketing and communication services (such as newsletters), delivering customer support, and other necessary activities integral to our operations.

-&nbsp;**Affiliated Companies**

To ensure seamless service delivery, we may share your information with entities connected to BINANY, including affiliates and subsidiaries, where such collaboration is essential for offering relevant products and services.

-&nbsp;**Governmental and Regulatory Bodies**

If required by law, we may disclose your data to governmental authorities, regulatory bodies, or courts. Such disclosures are limited to the minimum necessary to comply with legal obligations or enforce court mandates.

-&nbsp;**Specific Circumstances**

In unique circumstances, we may share your data to protect our legal rights, ensure the safety of users, or address incidents that require action, such as fraud prevention or dispute resolution. Additionally, we may disclose information to establish, exercise, or defend against legal claims when necessary.


We take all reasonable steps to ensure that third-party service providers entrusted with collecting, storing, or processing data for us:

-&nbsp;Establish contracts that safeguard data privacy in accordance with this Privacy Policy and relevant information security standards

-&nbsp;Have confidentiality or non-disclosure agreements that include privacy clauses;

-&nbsp;Implement procedures to comply with data protection agreements.

Should any misuse or unauthorized disclosure of personal data by a third-party service provider occur, we will take appropriate corrective actions.


If you wish to receive more information about data transfers mentioned here, please contact us using the email registered in your Client Account, as listed in the section OUR CONTACT DETAILS below.

7. **7. DATA STORAGE DURATION**

We retain your personal data only as long as is reasonably necessary to fulfill the purposes for which it was collected, including compliance with legal, tax, accounting, and reporting requirements. If there is a complaint or a potential legal dispute, we may hold your data for an extended period.


To determine the appropriate retention period, we consider factors such as the amount and sensitivity of the data, the risk of harm from unauthorized use or disclosure, the purposes for data processing, the possibility of achieving those purposes through alternative methods, and applicable legal requirements.


Your data, including call recordings, will be stored for the duration of our contractual relationship and for a minimum of seven years after the end of the service provided to you. Generally, any other data is retained for 30 business days following the termination of our services, unless there is a specific legal reason to keep it longer.


At the end of the retention period, the data is permanently deleted through irreversible destruction. Additionally, we inform all third parties who have received your data of the deletion and request that they perform a similar action in compliance with our policy.

8. **8. YOUR RIGHTS AND HOW TO ASSERT THEM**

We ask that you provide us with accurate, truthful, and updated information about your identity and avoid misrepresenting yourself as another individual or legal entity. If there are any changes to your personal details, please notify us promptly, no later than seven days after such changes occur. If your data is incorrect or incomplete, contact us using the details in the section OUR CONTACT DETAILS below to update it.


Under applicable laws, you have several rights concerning your data, and we encourage you to contact us to discuss these rights. Below is a summary of the key rights you have:

1.&nbsp;**Right to Access:** You have the right to request confirmation as to whether we process your personal data (Article 15 GDPR). If so, you may access it and receive additional details on the purposes of processing, data categories, recipients, and retention period. You can view your data in your account by selecting "Access My Data"
   
2.&nbsp;**Right to Rectification:** Under Article 16 GDPR, you have the right to request the correction of any inaccurate or incomplete personal data we hold about you. If your information is incorrect or has changed, please contact us to update it.
   
3.&nbsp;**Right to Erasure:** According to Article 17 GDPR, you may request the deletion of your personal data if it is no longer needed for its original purpose, if you withdraw your consent, or if there are no overriding legal grounds for processing. To delete your account and data, go to ‘Terminate Account’ and select "Delete My Account".
   
4.&nbsp;**Right to Restriction of Processing:** You have the right to request a restriction on data processing if (a) your data is inaccurate, (b) processing is unlawful but you do not wish for it to be erased, (c) we no longer need the data but you want us to retain it for legal reasons, or (d) you object to the use of your data, and we are verifying whether we have overriding legitimate grounds to continue processing it (Article 18 GDPR).
   
5.&nbsp;**Right to Data Portability:** When processing is based on consent and conducted via automated means, you have the right to receive your data in a structured, commonly used, and machine-readable format (Article 20 GDPR). This right does not apply if it would negatively affect the rights and freedoms of others or if it is technically unfeasible.
   
6.&nbsp;**Right to Object:** Under Article 21 GDPR, you have the right to object to data processing when based on our legitimate interests or a task in the public interest. Upon objection, we will stop processing your data unless we can demonstrate overriding legitimate grounds.
   
7.&nbsp;**Right to Withdraw Consent:** According to Article 7(3) GDPR, you may withdraw your consent to data processing at any time, particularly for marketing or third-party data sharing. Withdrawal will not impact the legality of processing conducted prior to withdrawal.
   
8.&nbsp;**Right to Lodge a Complaint with a Supervisory Authority:** We strive to protect your data and keep you informed about our data processing practices. If you are unsatisfied with our processing or data protection efforts, we encourage you to let us know, so we can improve. You can also contact the relevant data protection supervisory authority to file a complaint (Article 77 GDPR).

To exercise any of these rights or seek more details, contact us through the methods in the OUR CONTACT DETAILS section below. Provide your full name and email address to help us identify you. We aim to respond to all legitimate requests within one month, although complex requests may take longer, in which case we will keep you informed.


We may request additional information to verify your identity and ensure your right to access data (or exercise other rights). This is a security measure to prevent unauthorized access to personal information. In some cases, we may charge an administrative fee for processing excessive or unreasonable requests or for additional copies of your data.

9. **9. PROTECTING YOUR INFORMATION**

We have put in place appropriate security measures to prevent your data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. Access to your data is limited to those employees, agents, contractors, and other third parties who have a business need to know. They will only process your data on our instructions, and they are subject to a duty of confidentiality.


We have established procedures to handle any suspected data breach and will notify you of a breach where we are legally required to do so.


Your help is essential in ensuring that your data remains secure. During registration on the Website (or its mobile version), you will be asked to select a username and password for future logins and conducting transactions. To protect your privacy and secure your operations on the Website, sharing registration details (including your username and password) with others is strictly prohibited. We are not responsible for any damage or loss resulting from improper or unauthorized use of your username and password, including by third parties, regardless of whether you authorized such use.


The Company’s live public chat feature is not an official channel of communication between the Company and you. We will never communicate with you through this chat feature or request any information via it. This chat feature is designed for public conversations, allowing users to interact with each other on topics of interest in real-time. Please note that any information shared in the live public chat can be accessed by anyone, and we are not responsible for any content shared or actions taken based on it.


BINANY follows the principles of “Data Protection by Design and by Default" as set out in Articles 24 and 25 GDPR. This approach ensures that our systems and processes are designed to incorporate data protection measures from the outset, minimizing data usage and safeguarding personal information at every stage.


**Encryption of your data in transit.** We use strong encryption technologies, such as Transport Layer Security (TLS), to protect your data during its transmission from your device to our servers, providing a high level of security and privacy. To further build trust, we use Extended Validation (EV) Certificates issued by trusted Certificate Authorities. Supported browsers will display a “Green Bar,” confirming that all transmitted data is secure.


**Protection of your data in our infrastructure.** We prioritize “security by default” in all services, meaning that every new service or feature is designed with strict security requirements from the beginning. To safeguard your data, we use pseudonymization for most services, replacing identifiable data with system IDs, making it difficult to trace back to you.


All equipment used for processing your data is located in secure data centers, with network access isolated from the internet. We apply network segmentation to separate services with different security levels and restrict access to your data for employees on a “need to know” basis only. This ensures that only personnel who need access to your data to provide optimal service will have it.


**Threats protection.** We are constantly vigilant about data security threats and are prepared to address them. All events in our infrastructure are continuously monitored, analyzed, and responded to, keeping your data secure from threats, vulnerabilities, and malware.


In case of any failure affecting the availability of your data, we have data backup and recovery procedures to restore your data quickly. To ensure fast recovery, we use high availability mode for critical databases, minimizing downtime.


**Employee awareness of data security.** Our employees may need access to your data to provide you with high-quality service. To ensure data security and confidentiality, we monitor employee actions in systems where your data is accessed, granting access strictly on a “need to know” basis. Regular training sessions are held to ensure each employee understands our data security and privacy principles.


**If you choose not to give your personal information.** In the course of our business relationship, we may need to collect certain data due to legal requirements or contractual obligations. Without this data, we may be unable to establish or fulfill a contract with you, which could delay or prevent us from providing services or managing your accounts.


**To what extent we carry automated decision-making and profiling.** Generally, we do not use automated decision-making when establishing or managing a business relationship. If automated decision-making is used in specific cases, we will inform you in advance. Profiling may occasionally be conducted to assess certain personal characteristics, and if it is performed, we will notify you **accordingly.**

10. **10. HOW TO CONTACT US**

We have appointed a Data Protection Officer (DPO) who is responsible for overseeing any questions or concerns you may have regarding this Privacy Policy. If you have questions about this policy, including any requests related to your data, please contact the DPO using the contact information provided below:


**Email:**  [support@binany.com](mailto:support@binany.com)


To help us process your request efficiently, please contact us using the email address that you registered with your Client Account. We may also require you to provide proof of identity, such as a valid identification form, to ensure that we protect your personal data from unauthorized access and comply with our security obligations.


If you have further questions or need more details about how we use your data, please feel free to reach out to us through the contact methods listed above, and we will gladly provide additional **information.**

11. **11. EXTERNAL WEBSITE LINKS**

Our Website may include links to third-party websites. These linked sites are not under our control, and we cannot accept responsibility or liability for the actions of these third parties, including their collection or use of your data. We encourage you to review the terms and privacy policies of any third-party website before providing your personal data there.

12. **12. UPDATES TO THIS PRIVACY POLICY**

This Privacy Policy was last updated on November 8, 2024. We reserve the right to amend, modify, or remove portions of this Privacy Policy in the future to ensure it accurately reflects how we handle and process your data.


We may supplement this Privacy Policy with additional information that you receive from us or through other terms and conditions related to the Website or any agreements you enter into with us.


When changes to this policy are made, the revised Privacy Policy will be posted on our Website. Any updates will take effect immediately upon posting. We welcome your comments and feedback, and you may contact us at any time using the details in the section OUR CONTACT DETAILS above.
`